import { Type } from "class-transformer";
import {
  IsArray,
  IsBoolean,
  IsDate,
  IsNumber,
  ValidateIf,
  ValidateNested,
} from "class-validator";
import TransmedFormSection from "./section";
import TransmedRegistration from "../registration/registration";

export default class OutputTransmedForm {
  @IsBoolean() public readonly coordinator!: boolean;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransmedFormSection)
  public readonly sections!: TransmedFormSection[];

  @IsNumber() public readonly max_points!: number;

  @ValidateIf((obj) => obj.registration !== null)
  @Type(() => TransmedRegistration)
  @ValidateNested()
  public readonly registration!: TransmedRegistration | null;

  @ValidateIf((obj) => obj.points_deadline_first !== null)
  @Type(() => Date)
  @IsDate()
  public readonly points_deadline_first!: Date;
}
